import clsx, { type ClassValue } from "clsx";

/** Tiny className combiner. Mirrors Lane's helper of the same name. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
